module.exports = __webpack_public_path__ + "img/28.20f8fe51.png";